import { create } from 'apisauce';
import { getToken } from 'helper/storage';

export const apiClient = create({
    baseURL: 'https://api.sharif-school.ir/api',
})

apiClient.addAsyncRequestTransform(async (request) => {
    let authToken = await getToken();
    if (!authToken) return;

    request.headers["Authorization"] = "Bearer " + authToken;
})
export default apiClient;